import { useState } from 'react';
import type { FormEvent } from 'react';
import InputBase from '@mui/material/InputBase';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import { nexusColors } from '@/theme';

export function SearchBar({ onSubmit, defaultValue = '', placeholder = 'Search the wiki…' }: {
  onSubmit: (query: string) => void;
  defaultValue?: string;
  placeholder?: string;
}): JSX.Element {
  const [q, setQ] = useState(defaultValue);

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (q.trim()) onSubmit(q.trim());
  }

  return (
    <Paper
      component="form"
      onSubmit={handleSubmit}
      elevation={0}
      sx={{
        display: 'flex',
        alignItems: 'center',
        px: 1.25,
        py: 0.25,
        bgcolor: nexusColors.bgCard,
        border: `1px solid ${nexusColors.line}`,
        borderRadius: 2,
      }}
    >
      <SearchIcon fontSize="small" sx={{ color: nexusColors.faint, mr: 0.75 }} />
      <InputBase
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder={placeholder}
        fullWidth
        sx={{ fontSize: 14, color: nexusColors.ink }}
        inputProps={{ 'aria-label': 'Search the wiki' }}
      />
      <IconButton type="submit" size="small" aria-label="Submit search" sx={{ color: nexusColors.muted }}>
        <SearchIcon fontSize="small" />
      </IconButton>
    </Paper>
  );
}
